import Vue from 'vue'
import VueRouter from 'vue-router'
import VueCookies from 'vue-cookies'
import recruiter_home from '@/views/home.vue'

const recruiter_dashboard = () => import(/* webpackPrefetch: true */ /* webpackChunkName: "employer-side" */ "@/views/Dashboard.vue");
const rec_register = () => import(/* webpackPrefetch: true */ /* webpackChunkName: "employer-side" */ "@/views/Register.vue");
const jobDescription = () => import(/* webpackPrefetch: true */ /* webpackChunkName: "employer-side" */ "@/views/JobDescription.vue");
const privateJobDescription = () => import(/* webpackPrefetch: true */ /* webpackChunkName: "employer-side" */ "@/views/PrivateJobDescription.vue");
const rec_login = () => import(/* webpackPrefetch: true */ /* webpackChunkName: "employer-side" */ "@/views/SignIn.vue");
const jobPost = () => import(/* webpackPrefetch: true */ /* webpackChunkName: "employer-side" */ "@/views/JobPost.vue");
const privateJobPost =() =>  import(/* webpackPrefetch: true */ /* webpackChunkName: "employer-side" */ "@/views/PrivateJobPost.vue");
const privacy = () => import(/* webpackPrefetch: true */ /* webpackChunkName: "employer-side" */ "@/views/Privacy.vue");
const contact_us = () => import(/* webpackPrefetch: true */ /* webpackChunkName: "seeker-side" */ "@/views/ContactUs.vue");
const refund = () => import(/* webpackPrefetch: true */ /* webpackChunkName: "employer-side" */ "@/views/Refund.vue");
const pageNotFound = () => import(/* webpackPrefetch: true */ /* webpackChunkName: "employer-side" */ "@/views/pageNotFound.vue");
const jobResponse = () => import(/* webpackPrefetch: true */ /* webpackChunkName: "employer-side" */ "@/views/Responses.vue");
const empRedirect = () => import(/* webpackPrefetch: true */ /* webpackChunkName: "employer-side" */ "@/views/redirect.vue");
const employerProfile = () => import(/* webpackPrefetch: true */ /* webpackChunkName: "employer-side" */ "@/views/Profile.vue");
const jobEdit = () => import(/* webpackPrefetch: true */ /* webpackChunkName: "employer-side" */ "@/views/JobEdit.vue");
const forgotPassword = () => import(/* webpackPrefetch: true */ /* webpackChunkName: "seeker-side" */ "@/views/ForgotPassword.vue");
const forgotPasswordRequest = () => import(/* webpackPrefetch: true */ /* webpackChunkName: "seeker-side" */ "@/views/ForgotPasswordRequest.vue");
const joinRoom = () => import(/* webpackPrefetch: true */ /* webpackChunkName: "seeker-side" */ "@/views/JoinRoom.vue");
const conference = () => import(/* webpackPrefetch: true */ /* webpackChunkName: "seeker-side" */ "@/views/Conference.vue");

const questionnaire = () => import(/* webpackPrefetch: true */ /* webpackChunkName: "employer-side" */ "@/views/Questionnaire.vue");
// const candidateSearch = () => import(/* webpackPrefetch: true */ /* webpackChunkName: "employer-side" */ "@/views/CandidateSearch.vue");
// const candidateSearchResult = () => import(/* webpackPrefetch: true */ /* webpackChunkName: "employer-side" */ "@/views/CandidateSearchResult.vue");
// const jobfairs = () => import(/* webpackPrefetch: true */ /* webpackChunkName: "employer-side" */ "@/views/JobfairDashboard.vue");
const preview_jobfair = () => import(/* webpackPrefetch: true */ /* webpackChunkName: "employer-side" */ "@/views/PreviewJobfair.vue");
const manage_jobfair_jobs = () => import(/* webpackPrefetch: true */ /* webpackChunkName: "employer-side" */ "@/views/ManageJobfairJobs.vue");
const manageTemplates = () => import(/* webpackPrefetch: true */ /* webpackChunkName: "employer-side" */ "@/views/ManageTemplate.vue");
const scheduledInterviews = () => import(/* webpackPrefetch: true */ /* webpackChunkName: "employer-side" */ "@/views/ScheduledInterview.vue");
const package_pricing = () => import(/* webpackPrefetch: true */ /* webpackChunkName: "employer-side" */ "@/views/PackagePricing.vue");
const payment = () => import(/* webpackPrefetch: true */ /* webpackChunkName: "employer-side" */ "@/views/Payment.vue");

import candidateDashboard from "@/views/CandidateDashboard.vue";

/* Vue Routes*/

const routes = [
    {
        path: '/recruit',
        name: 'recruiter_home',
        component: recruiter_home,
        meta: { title: 'Hire from video profiles - Entry level recruitment solution in India - Hireclap',
                metaTags:[
                  {name:'description',content:'Hire from video profiles & post free job. Hireclap recruitment solutions - virtual candidate sourcing,profile search, job fairs, assessment, on/off campus hiring events '},
                  {name:'keywords',content:'Video Profile, Post job,Employers, Recruitment Drive, Entry Level Hiring, Campus Recruitment Solutions, Freshers Hiring, Recruiters, online assessment, ATS, Online Resume Management System'},
                  // {property: 'og:title', content: 'Hire from video profiles - Entry level recruitment solution in India - Hireclap'},
                  // {property: 'og:description', content: 'Hire from video profiles & post free job. Hireclap recruitment solutions - virtual candidate sourcing,profile search, job fairs, assessment, on/off campus hiring events '},
                ]
              }
    },
    {
        path: '/recruit/register',
        name: 'rec_register',
        get component(){
          if(window.$cookies.get("hire-employer") == null){
            return rec_register
          }else{
            return recruiter_dashboard
          }
        },
        meta: { title: 'Employer registration-Post free job-Hire candidates - Hireclap',
                metaTags:[
                  {name:'description',content:'Employer registration.Post free job and hire candidates for vacancies'},
                  {name:'keywords',content:'Employer registration,Post free job, recruiter,job, hire, candidates, fresher,hiring'},
                  // {property: 'og:title', content: 'Employer registration-Post free job-Hire candidates - Hireclap'},
                  // {property: 'og:description', content: 'Employer registration.Post free job and hire candidates for vacancies'},
                ]
              }
    },
    {
        path: '/recruit/login',
        name: 'rec_login',
        props: true,
        get component(){
          if(window.$cookies.get("hire-employer") == null){
            return rec_login
          }else{
            return recruiter_dashboard
          }
        },
        meta: { title: 'Recruiter signin - Post free job - Hireclap' ,
                metaTags:[
                  {name:'description', content:'Recruiter signin page and post free jobs.Recruiters can find the best matching candidates from the 2 minute job seekers video profiles. Post your entry level fresher hiring requirment & hire from largest pool of candidates '},
                  {name:'keywords',content:'Recruiter, Sigin, post job'},
                  // {property: 'og:title', content: 'Recruiter signin - Post free job - Hireclap'},
                  // {property: 'og:description', content: 'Recruiter signin page and post free jobs.Recruiters can find the best matching candidates from the 2 minute job seekers video profiles. Post your entry level fresher hiring requirment & hire from largest pool of candidates '},
                ]
              }
    },
    {
        path: '/recruit/client-job-dashboard',
        name: 'recruiter_dashboard',
        get component(){
          if(window.$cookies.get("hire-employer") != null){
            return recruiter_dashboard
          }else{
            return recruiter_home
          }
        },
        meta: { title: 'Employer dashboard - Hireclap' ,
                metaTags:[
                  {name:'description',content:'Employer dashboard page to manage jobs, access applicants profiles, download job applicants details etc '},
                  {name:'keywords',content:'Employer,dashboard,manage jobs, applicants profiles'},
                  // {property: 'og:title', content: 'Employer dashboard - Hireclap'},
                  // {property: 'og:description', content: 'Employer dashboard page to manage jobs, access applicants profiles, download job applicants details etc '},
                ]
              },
    },
    // {
    //   path:'/recruit/candidate-search',
    //   name: 'candidate_search',
    //   props: true,
    //   get component(){
    //     if(window.$cookies.get("emp_token")){
    //       return candidateSearch
    //     }else{
    //       return recruiter_home
    //     }
    //   },
    //   meta: { title: 'Candidate Search - Hireclap',
    //     metaTags:[
    //       {name:'description',content:'Candidate search page at Hireclap.'},
    //       {name:'keywords', content:'Employer , search, company, account'},
    //       {property: 'og:title', content: 'Candidate Search - Hireclap'},
    //       {property: 'og:type', content: 'website'},
    //       {property: 'og:url', content: window.location.href},
    //       {property: 'og:description', content: 'Candidate search page at Hireclap.'},
    //       {property: 'og:image', content: 'https://s3.ap-south-1.amazonaws.com/static.testengine.com/justin/images/hireclap-logo-HD.png'},
    //       {property: 'og:site_name', content: 'hireclap.com'},
    //     ]
    //   }
    // },
    // {
    //   path:'/recruit/candidate-search',
    //   name: 'candidate_search',
    //   props: true,
    //   get component(){
    //     if(window.$cookies.get("hire-employer") != null){
    //       return candidateSearch
    //     }else{
    //       return recruiter_home
    //     }
    //   },
    //   meta: { title: 'Candidate Search - Hireclap',
    //     metaTags:[
    //       {name:'description',content:'Candidate search page at Hireclap.'},
    //       {name:'keywords', content:'Employer , search, company, account'},
    //       {property: 'og:title', content: 'Candidate Search - Hireclap'},
    //       {property: 'og:type', content: 'website'},
    //       {property: 'og:url', content: window.location.href},
    //       {property: 'og:description', content: 'Candidate search page at Hireclap.'},
    //       {property: 'og:image', content: 'https://s3.ap-south-1.amazonaws.com/static.testengine.com/justin/images/hireclap-logo-HD.png'},
    //       {property: 'og:site_name', content: 'hireclap.com'},
    //     ]
    //   }
    // },
    // {
    //   path:'/recruit/candidate-search-result',
    //   name: 'candidate_search_result',
    //   props: true,
    //   get component(){
    //     if(window.$cookies.get("hire-employer") != null){
    //       return candidateSearchResult
    //     }else{
    //       return recruiter_home
    //     }
    //   }
    // },
    {
      path: '/recruit/candidate-dashboard/:id/:job_id',
      name: 'candidate_dashboard',
      component: candidateDashboard,
      props: true,  
      meta: { title: 'Candidate Dashboard- Hireclap', requiresAuth: true ,
            // metaTags:[
            //   {property: 'og:title', content: 'Hire from video profiles - Entry level recruitment solution in India - Hireclap'},
            //   {property: 'og:description', content: 'Hire from video profiles & post free job. Hireclap recruitment solutions - virtual candidate sourcing,profile search, job fairs, assessment, on/off campus hiring events '},
            // ]
          }
    },
    {
      path: '/recruit/manage-templates',
      name: 'manage_templates',
      component: manageTemplates,
      meta:{
        title: 'Manage Templates', requiresAuth: true
      },
      props: true
    },
    {
      path: '/recruit/job/questionnaire/:id',
      name: 'questionnaire',
      component: questionnaire,
      props: false,
      meta: { title: 'Questionnaire -Hireclap',
              // metaTags:[
              //   {property: 'og:title', content: 'Hire from video profiles - Entry level recruitment solution in India - Hireclap'},
              //   {property: 'og:description', content: 'Hire from video profiles & post free job. Hireclap recruitment solutions - virtual candidate sourcing,profile search, job fairs, assessment, on/off campus hiring events '},
              // ]
            }
    },
    {
      path: '/recruit/scheduled-interviews',
      name: 'scheduled_interviews',
      component: scheduledInterviews,
      meta:{
        title: 'Scheduled Interviews', requiresAuth: true
      }
    },
    {
      path: '/recruit/join_room',
      name: 'join_room',
      component: joinRoom,
      props: true
    },
    {
      path: '/recruit/conference_room',
      name: 'conference_room',
      component: conference,
    },
    {
      path: '/recruit/package-pricing',
      name: 'package_pricing',
      component: package_pricing,
      meta:{
        title: 'Pricing'
      }
    },
    {
      path: '/recruit/payment',
      name: 'payment',
      // component: payment,
      props: true,
      component: payment,
      meta:{
        title: 'Payment'
      }
    },
    // {
    //   path: '/recruit/job/questionnaire/:id',
    //   name: 'questionnaire',
    //   component: questionnaire,
    //   props: false,
    // },
    // {
    //   path:'/recruit/candidate-search-result',
    //   name: 'candidate_search_result',
    //   props: true,
    //   get component(){
    //     if(window.$cookies.get("emp_token")){
    //       return candidateSearchResult
    //     }else{
    //       return recruiter_home
    //     }
    //   }
    // },
    {
      path: '/recruit/profile',
      name: 'employer_profile',
      component: employerProfile,
      meta: { title: 'Employer My profile - Hireclap',
              metaTags:[
                {name:'description',content:'Employer profile page at Hireclap. Company name , contact details , Hiring details '},
                {name:'keywords', content:'Employer , profile, company, account'},
                // {property: 'og:title', content: 'Employer My profile - Hireclap'},
                // {property: 'og:description', content: 'Employer profile page at Hireclap. Company name , contact details , Hiring detaisl '},
              ]
            },
      props: true 
    },
    {
      path: '/recruit/reset_password',
      name: 'forgot_password',
      component: forgotPassword,
      meta: { title: 'Reset Password'}
    },
    {
      path: '/recruit/request_password',
      name: 'forgot_password_request',
      component: forgotPasswordRequest,
      meta: { title: 'Request Password'}
    },
    {
        path: '/recruit/post-job',
        name: 'post_job',
        component: jobPost,
        meta: { title: 'Post free jobs - Hire fresher entry level candidates - Hireclap ',
                metaTags:[
                  {name: 'description',content: 'Post a free job.Post your job vacancy online and hire matching candidates virtually. Ease hiring using online recruitment tools '},
                  {name:'keywords',content:'Post free job, entry level, fresher , vacancies,job title, job description, salary,job location'},
                  // {property: 'og:title', content: 'Post free jobs - Hire fresher entry level candidates - Hireclap '},
                  // {property: 'og:description', content: 'Post a free job.Post your job vacancy online and hire matching candidates virtually. Ease hiring using online recruitment tools '},
                ]
              }
    },
    {
      path: '/recruit/post-private-job',
      name: 'post_private_job',
      component: privateJobPost,
      meta: { title: 'Post private jobs - Hire fresher entry level candidates - Hireclap ',
              metaTags:[
                {name: 'description',content: 'Post a private job.Post your job vacancy online and hire matching candidates virtually. Ease hiring using online recruitment tools '},
                {name:'keywords',content:'Post private job, entry level, fresher , vacancies,job title, job description, salary,job location'},
                // {property: 'og:title', content: 'Post free jobs - Hire fresher entry level candidates - Hireclap '},
                // {property: 'og:description', content: 'Post a free job.Post your job vacancy online and hire matching candidates virtually. Ease hiring using online recruitment tools '},
              ]
            }
    },
    {
      path: '/recruit/edit/:id/:type/:user_id',
      name: 'edit_job',
      component: jobEdit,
      meta: { title: 'Job edit - Hireclap' ,
      metaTags:[
        {name: 'description',content: 'Job edit page for Hireclap'},
        {name:'keywords',content:'Job , edit '},
        // {property: 'og:title', content: 'Job edit - Hireclap'},
        // {property: 'og:description', content: 'Job edit page for Hireclap'},
      ]
    },
    },
    {
        path: '/recruit/jobs/:id/:type/:user_id',
        name: 'job_description',
        component: jobDescription,
        meta: { title: 'Hireclap'},
        props: true
    },
    {
      path: '/recruit/private_jobs/:id/:type/:user_id',
      name: 'private_job_description',
      component: privateJobDescription,
      meta: { title: 'Hireclap'},
      props: true
    },
    {
      path: '/recruit/responses/:job',
      name: 'job_responses',
      // component: jobResponse,
      get component(){
        if(window.$cookies.get("hire-employer") != null){
          return jobResponse
        }else{
          return recruiter_home
        }
      },
      meta: { title: 'Manage job responses - Hireclap',
              metaTags:[
                {name: 'description',content: 'Manage job response page to view & access applicants for a job posting '},
                {name:'keywords',content:'Manage job responses,access applicants,job posting '},
                // {property: 'og:title', content: 'Manage job responses - Hireclap'},
                // {property: 'og:description', content: 'Manage job response page to vew & access applicants for a job posting '},
              ]
            },
      props: true 
    },
    {
      path: '/recruit/jobfair/preview/:id',
      name: 'preview_jobfair',
      component: preview_jobfair,
      meta: { title: 'Preview Jobfair', requiresAuth: true },
      props: true
    },
    {
      path: '/recruit/jobfair/manage_jobs/:id',
      name: 'manage_jobfair_jobs',
      component: manage_jobfair_jobs,
      meta: { title: 'Manage jobs ib Jobfair', requiresAuth: true },
      props: true
    },
    {
      path: '/recruit/emp_al',
      name: 'empRedirect',
      component: empRedirect,
      mata: { title: 'Hireclap' }
    },
    {
      path:'/recruit/privacy',
      name: 'privacy',
      component: privacy,
      meta:{
        title: 'Hireclap'
      }
    },
    {
      path:'/recruit/contact-us',
      name: 'contact_us',
      component: contact_us,
      meta: { title: 'Contact us - Hireclap',
      metaTags:[
        {name:'description',content:'Contact us page to submit comments, queries, and questions, etc about Hireclap.com'},
        {name:'keywords',content:'Job seeker, contact us submit comments, queries, questions'},
        {property: 'og:title', content: 'Contact us - Hireclap'},
        {property: 'og:type', content: 'website'},
        {property: 'og:url', content: window.location.href},
        {property: 'og:description', content: 'Contact us page to submit comments, queries, and questions, etc about Hireclap.com'},
        {property: 'og:image', content: 'https://d22r5huxahsjvt.cloudfront.net/Assets/images/hireclap-logo-HD.png'},
        {property: 'og:site_name', content: 'hireclap.com'},
      ]},
      gtm: 'Contact Us'
    },
    // {
    //   path:'/recruit/refund',
    //   name: 'terms',
    //   component: terms,
    //   meta:{
    //     title: 'Hireclap'
    //   }
    // },
    {
      path:'/recruit/refund-policy',
      name: 'refund',
      component: refund,
      meta:{
        title: 'Hireclap - Refund policy'
      }
    },
    {
      path: '/:catchAll(.*)',
      name: 'pageNotFound',
      component: pageNotFound,
      meta: { 
        title: 'Page not found - Hireclap',
        metaTags:[
              {name:'robots',content:'noindex'}
            ]
      }
    },
    
]

Vue.use(VueCookies);

const router = new VueRouter({
    mode: 'history', //to remove # from url
    routes: routes
})

router.beforeEach((to, from, next) => {
  const nearestWithTitle = to.matched.slice().reverse().find(r => r.meta && r.meta.title);
  const nearestWithMeta = to.matched.slice().reverse().find(r => r.meta && r.meta.metaTags);
  const previousNearestWithMeta = from.matched.slice().reverse().find(r => r.meta && r.meta.metaTags);

  if(nearestWithTitle) {
    document.title = nearestWithTitle.meta.title;
  } else if(previousNearestWithMeta) {
    document.title = previousNearestWithMeta.meta.title;
  }

  Array.from(document.querySelectorAll('[data-vue-router-controlled]')).map(el => el.parentNode.removeChild(el));
  if(!nearestWithMeta) return next();

  nearestWithMeta.meta.metaTags.map(tagDef => {
    const tag = document.createElement('meta');

    Object.keys(tagDef).forEach(key => {
      tag.setAttribute(key, tagDef[key]);
    });
    // tag.setAttribute('data-vue-router-controlled', '');
    return tag;
  }).forEach(tag => document.querySelector("[property = 'og:locale']").after(tag));

  next();
})

export default router;
